import { Component, Input } from '@angular/core'
import { IconNameUnion } from '@app-domains/ui/directives/icon/icon.directive.types'

@Component({
    selector: 'app-icon-message-header',
    templateUrl: './icon-message-header.component.html',
    styleUrls: ['./icon-message-header.component.scss'],
})
export class IconMessageHeaderComponent {
    @Input()
    public title: string

    @Input()
    public subtitle?: string

    @Input()
    public icon?: IconNameUnion = 'warning-circle'
}
